/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TMobileGetContextModel,
  IMobileGetContextRequest,
  IMappers,
  IMobileGetContextResponse,
  IMobileGetContextResponseError,
  TMobileGetContextResponse,
} from './types';

const defaultConfig: TMobileGetContextModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/addform/v1/mobile/get-context/',
  hostType: 'api',
  responseType: 'json',
} as TMobileGetContextModel;

function createMobileGetContextModel(parameters: IMobileGetContextRequest): TMobileGetContextModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IMobileGetContextOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IMobileGetContextRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchMobileGetContext<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IMobileGetContextOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TMobileGetContextResponse
> {
  const { response, statusCode } = await httpApi.fetch(createMobileGetContextModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMobileGetContextResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IMobileGetContextResponseError);
    }
  }

  return { response, statusCode } as TMobileGetContextResponse;
}

export { defaultConfig, createMobileGetContextModel, fetchMobileGetContext };
